import React, {ReactElement, useState} from "react";
import {StyledBoxColumn, StyledMarkdown} from "../../shared/StyledComponents";
import {PAGE_FRAGMENT_SM_WIDTH, PD_LG, SZ_LG} from "../../shared/dimens";
import {AskWyzeImage} from "../../libwyze-shared/components/AskWyzeImage";
import {Button, CircularProgress} from "@mui/material";
import {AskWyzeView, AskWyzeViewMode} from "./AskWyzeView";
import {AskWyzeParticipantKey} from "./types";
import {AppPrefs} from "./app_prefs";
import {BaseApp} from "../../shared/BaseApp";
import {MessagesContextTrait} from "../../app-modules/messages/types";
import {ChatMessages, ChatThread, ChatThreads, MessageFactory} from "../../app-modules/messages/chat/types";
import {AccountProfileContextTrait} from "../../libwyze-shared/types";

export function AskWyzeFragment(props: {
  mode: AskWyzeViewMode,
  setMode: (mode: AskWyzeViewMode) => void,
}): ReactElement {
  const [accepted, setAccepted] = useState<boolean>(AppPrefs.getInstance().getAskWyzeTermsAccepted());
  const [selectedChatThreadId, setSelectedChatThreadId] = useState<string>();
  if (!accepted) {
    return <StyledBoxColumn style={{
      width: "100%",
      flexGrow: 1,
      maxWidth: PAGE_FRAGMENT_SM_WIDTH,
      alignSelf: "center",
      padding: PD_LG,
      justifyContent: "center"
    }}>
      {accepted !== undefined
        ? <>
          <AskWyzeImage size={SZ_LG}/>
          <StyledMarkdown style={{opacity: 0.5}}>
            {"Welcome to Ask Wyze™, an AI-powered assistant to help you get more done faster. Get answers to your questions about your practice operations, best practices, and retrieve information about your available resources."}
          </StyledMarkdown>
          <Button
            onClick={() => {
              BaseApp.CONTEXT.showConfirmDialog("Ask Wyze is a preview product, and may display inaccurate information. Your prompts are may be used to improve the model. Press confirm if you accept these conditions.", () => {
                AppPrefs.getInstance().setAskWyzeTermsAccepted(true);
                setAccepted(true);
              })
            }}
            variant={"contained"}>
            Get Ask Wyze
          </Button>
          <Button>
            Learn More
          </Button>
        </>
        : <CircularProgress style={{alignSelf: "center"}}/>}
    </StyledBoxColumn>;
  }
  return <AskWyzeView
    mode={props.mode}
    setMode={props.setMode}
    selectedChatThreadId={selectedChatThreadId}
    onNewWyzeChat={(chat) => {
      BaseApp.CONTEXT.showProgressDialog("Creating thread...", null, async function () {
        const practiceId = BaseApp.CONTEXT.getTrait<AccountProfileContextTrait>().getPracticePageId();
        const myParticipantKey = BaseApp.CONTEXT.getTrait<MessagesContextTrait>().getMyParticipantKey();
        const from = myParticipantKey;
        const to = AskWyzeParticipantKey(practiceId);
        const thread = ChatThread.createNew([from, to]);
        const threads = ChatThreads.getInstance(myParticipantKey.type);
        await threads.onAfterItemDeserialized(thread);
        await threads.addListItem(thread);
        let message = MessageFactory.createTextMessage(thread.id, from, chat.message);
        await ChatMessages.getInstance(myParticipantKey.type, thread.id).addListItem(message);
        props.setMode(AskWyzeViewMode.CHAT);
        setSelectedChatThreadId(thread.id);
      });
    }}/>;
}